import { useEffect, useState, useRef } from "react"
import { useLocation, useParams } from "react-router-dom"
import { Alert, Button, Container, Table, Badge } from "reactstrap"
import Utils from "../../Utils"
import ModalCuota from "../../modals/ModalCuota"

const BotonFactura = ({ idPago, fetchPagos }) => {

    const [uploading, setUploading] = useState(false)

    const inputRef = useRef()

    const uploadFile = async (file) => {
        try {
            const formData = new FormData()
            formData.append("file", file)
            await Utils.API.SubirFactura(idPago, formData)
            alert("Factura subida satisfactoraimente!")
            // refresh
            fetchPagos()
        } catch(err) {
            Utils.AlertError(err, "No se pudo actualizar el PDF")
        }
    }

    const onFileChoose = ({ target }) => {
        if(target.files[0]) {
            uploadFile(target.files[0])
        }
    }

    if(uploading === true) {
        return(
            <Badge color="primary">Subiendo...</Badge>
        )
    }

    return(
        <>
            <Button className="m-2" color="warning" size="sm" onClick={() => { inputRef.current.click() }}>
                <i className="fa-solid fa-file-pdf"></i> Subir Boleta/Factura
            </Button>
            <input accept=".pdf" onChange={onFileChoose} ref={inputRef} style={{ display: "none" }} type="file" />
        </>
    )
}

const TablaPagos = ({ pagos, fetchPagos }) => {

    const [isOpen, setIsOpen] = useState(false)
    const [pago, setPago] = useState(null)

    const openModal = _pago => {
        setPago(_pago)
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    return(
        <>
            <Table className="text-center">
                <thead>
                    <tr>
                        <th>#Pago</th>
                        <th>Concepto</th>
                        <th>Fercha de Expiración</th>
                        <th>Monto</th>
                        <th>Estado</th>
                    </tr>
                </thead>
                <tbody>
                    {pagos.map(pago => {

                        const marcarPagado = async () => {
                            const monto = Number(pago.Monto) + Number(pago.moraActual)
                            let mensaje = `Realmente dese marcar "${pago.Concepto}" ($${pago.Monto}) como pagado?`
                            // check mora
                            if(pago.expirado) {
                                mensaje = mensaje + ` Mora: $${pago.moraActual}`
                            }
                            if(window.confirm(mensaje) == false) {
                                return;
                            }
                            // intentamos marcarlos
                            try {
                                await Utils.API.MarcarPago(pago.idPago, monto)
                                alert("Pagado!")
                                // refresh
                                fetchPagos()
                            } catch(err) {
                                Utils.AlertError(err, "No se pudo marcar el pago!")
                            }
                        }

                        return(
                            <tr id={`Pago${pago.idPago}`} key={pago.idPago}>
                                <td>{pago.idPago}</td>
                                <td>{pago.Concepto}</td>
                                <td>
                                    {["pagado", "facturando"].includes(pago.estado) == true ?
                                        <span>{Utils.dayjs(pago.FechaExpiracion).format("LL")}</span>
                                        :
                                        <span onClick={() => { openModal(pago) }} className="text-decoration-underline cursorLink">{Utils.dayjs(pago.FechaExpiracion).format("LL")}</span>
                                    }
                                </td>
                                <td>{pago.Monto}</td>
                                <td>
                                    {(pago.FechaPago == null) ?
                                        <>
                                            {pago.expirado ?
                                                <span className="text-danger">Sin Pagar ({pago.dias} días) / Mora: ${pago.moraActual}</span>
                                                :
                                                <span className="text-danger">Sin Pagar</span>
                                            }<br />
                                            <Button onClick={marcarPagado} size="sm">Marcar como Pagado</Button>
                                        </>
                                        :
                                        <>
                                            <Badge color="primary">{pago.MedioDePago}</Badge><br />
                                            {pago.Factura == null ?
                                                <span className="text-info">Pagado: Sin factura</span>
                                                :
                                                <a target="_blank" className="m-2 btn btn-success btn-sm" href={`${Utils.Backend}/Factura?token=${pago.tokenFactura}`}>
                                                    <i className="fa-solid fa-eye"></i> Ver Comprobante
                                                </a>
                                            }<br />
                                            <BotonFactura idPago={pago.idPago} fetchPagos={fetchPagos} />
                                        </>
                                        
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            <ModalCuota
                isOpen={isOpen}
                fetchPagos={fetchPagos}
                pago={pago}
                closeModal={closeModal}
            />
        </>
    )
}

const ListarPagos = () => {

    const location = useLocation()

    const checkScroll = () => {
        const hash = location.hash;
        if (hash) {
            const element = document.getElementById(hash.substring(1)); // Elimina el símbolo '#'
            if (element) {
                if(element.previousElementSibling) {
                    element.previousElementSibling.scrollIntoView({ behavior: 'smooth' })
                } else {
                    element.parentElement.parentElement.scrollIntoView({ behavior: 'smooth' })
                    console.log(element, element.previousSibling)
                }
                // verificamos si tiene premi
                /*if(element.previousElementSibling === null) {
                    element.parentElement.scrollIntoView({ behavior: 'smooth' });
                } else {
                    element.previousElementSibling.scrollIntoView({ behavior: 'smooth' });
                }*/
            }
        }
    }

    const { idUsuario } = useParams()

    const [pagos, setPagos] = useState(null)

    const fetchPagos = async () => {
        try {
            const { data } = await Utils.API.PagosUsuario(idUsuario)
            setPagos(data)
            setTimeout(checkScroll, 500)
        } catch(err) {
            Utils.AlertError(err, "No se pudo cargar los pagos del usuario")
        }
    }

    useEffect(() => {
        fetchPagos()
    }, [])

    return(
        <Container>
            {(pagos == null) ?
                <Alert className="text-center h3" color="info">Cargando...</Alert>
                :
                <>
                    <h1>Propiedades: {Object.keys(pagos).length}</h1>
                    {Object.keys(pagos).map(idLote => {
                        const propiedad = pagos[idLote]
                        const { Proyecto, ManzanaLote, Etapa } = pagos[idLote][0]
                        return(
                            <div key={idLote}>
                                <h3>{Proyecto} (Etapa {Etapa}) / {ManzanaLote}</h3>
                                <TablaPagos pagos={propiedad} fetchPagos={fetchPagos} />
                            </div>
                        )
                    })}
                </>
            }
        </Container>
    )
}
export default ListarPagos